// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../molecules/Modal';
import modalStyles from '../styles/FreeshippingModal.style';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import {
  ACCOUNT_ORDERS_LABEL,
  OrderDetailLabels,
  lblOrdersFree,
} from '../../../../features/account/OrderDetails/container/OrderDetails.labels';

class DynamicFreeSippingModal extends React.PureComponent {
  constructor() {
    super();
    this.shippingCharges = getDynamicLabelValues('dynamic.cart.lbl_shipping_charges');
    this.orderFreeLabel = getLabelFromCopyOrFromTranslation(
      `${ACCOUNT_ORDERS_LABEL}.${lblOrdersFree}`,
      OrderDetailLabels
    );
  }

  render() {
    const {
      openState,
      onRequestClose,
      additionalClassNameModal,
      freeShippingThreshold,
      dynamicShippingCharge,
      showShipToStoreMsg,
    } = this.props;
    return (
      <Modal
        isOpen={openState}
        onRequestClose={onRequestClose}
        overlayClassName="TCPModal__Overlay"
        className="TCPModal__Content"
        heightConfig={{ height: '90%' }}
        closeIconDataLocator="detailmodalcrossicon"
        heading={renderLabel(this.shippingCharges, 'lbl_shipping_charges')}
        fixedWidth
        customWrapperClassName={additionalClassNameModal}
        inheritedStyles={modalStyles}
        innerContentClassName="dfs-innerContent"
      >
        <div className="separator-header" />

        <div className="container">
          <div className="desc">
            <div className="sub-msg">
              <div className="desc-content">
                {' '}
                {renderLabel(
                  getDynamicLabelValues(`dynamic.browse_d.lbl_shipping_information`),
                  'lbl_shipping_information'
                )}{' '}
              </div>{' '}
            </div>
          </div>
          <div className="container1">
            <div className="main-msg">
              <div className="left">
                {' '}
                {renderLabel(
                  getDynamicLabelValues(`dynamic.browse_d.lbl_std_shipping_change`),
                  'lbl_std_shipping_change'
                )}{' '}
              </div>
              <div className="right">${dynamicShippingCharge || '6.99'}</div>
            </div>
            <div className="sub-msg">
              {renderLabel(
                getDynamicLabelValues(`dynamic.browse_d.lbl_shipping_threshold_msg`),
                'lbl_shipping_threshold_msg'
              )}{' '}
              ${freeShippingThreshold}
            </div>
          </div>

          {showShipToStoreMsg && (
            <>
              <div className="separator" />
              <div className="container2">
                <div className="main-msg">
                  <div className="left">
                    {' '}
                    {renderLabel(
                      getDynamicLabelValues('dynamic.browse_d.lbl_sts_shipping_charge'),
                      'lbl_sts_shipping_charge'
                    )}{' '}
                  </div>
                  <div className="right">{renderLabel(this.orderFreeLabel, lblOrdersFree)}</div>
                </div>
                <div className="sub-msg">
                  {' '}
                  {renderLabel(
                    getDynamicLabelValues('dynamic.browse_d.lbl_shipping_min_order_msg'),
                    'lbl_shipping_min_order_msg'
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </Modal>
    );
  }
}

DynamicFreeSippingModal.propTypes = {
  openState: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  additionalClassNameModal: PropTypes.string.isRequired,
};

export default DynamicFreeSippingModal;
